import * as React from "react";
const SvgFiRrCameraCctv = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-camera-cctv_svg__a)">
      <path
        fill="#062147"
        d="m21.3 11.077 1.312-1.018a1 1 0 0 0-.114-1.656L8.797.51A3.97 3.97 0 0 0 5.734.158 3.97 3.97 0 0 0 3.331 2.09l-.844 1.552c-1.034 1.9-.345 4.317 1.526 5.382l5.658 3.299-1.209 3.626A3 3 0 0 1 5.616 18H1.999v-3a1 1 0 0 0-2 0v8a1 1 0 0 0 2 0v-3h3.617a4.99 4.99 0 0 0 4.743-3.418l1.077-3.229 2.878 1.678a3.98 3.98 0 0 0 3.073.371 4 4 0 0 0 1.001-.437l1.592.883a1.22 1.22 0 0 0 1.66-.482l.844-1.547a1.22 1.22 0 0 0-.479-1.649l-1.137-.63q.178-.264.431-.461zm-4.46 2.4a1.98 1.98 0 0 1-1.527-.18L5.011 7.291a2.01 2.01 0 0 1-.768-2.694l.844-1.552a1.98 1.98 0 0 1 1.202-.966q.28-.08.561-.08c.335 0 .665.084.959.25l12.4 7.143-.135.105a4 4 0 0 0-1.06 1.245l-.966 1.77a1.98 1.98 0 0 1-1.208.965"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-camera-cctv_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCameraCctv;
